import React from 'react';
import greenBg from '../assets/green_bg.png';
import purpleBg from '../assets/purple_bg.webp';

const StatsSection = ({ stats, color, modifiers = /** @type {{ background?: string }} */ ({}) }) => {
  const bg = color === 'purple' ? purpleBg : greenBg;
  const textColor = color === 'purple' ? 'text-black' : 'text-white';
  const { background } = modifiers;

  return (
    <section
      className={`relative w-full py-10 md:py-20 px-2 md:px-0 ${textColor}`}
      style={
        background
          ? { background }
          : {
              minHeight: '220px',
              backgroundImage: `url(${bg})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }
      }
    >
      <div className="max-w-6xl mx-auto flex flex-col items-center justify-center">
        {/* Desktop layout */}
        <div className="hidden md:grid grid-cols-4 w-full bg-transparent">
          {stats.map((stat, idx) => (
            <div
              key={stat.value}
              className={`flex flex-col items-center px-4 ${
                idx !== stats.length - 1 ? 'border-r border-[#00000029]' : ''
              }`}
            >
              <span className="text-3xl font-bold mb-2 text-[40px] md:text-[48px]">{stat.value}</span>
              <span className="text-base opacity-80 text-center font-normal text-[18px]">{stat.label}</span>
            </div>
          ))}
        </div>
        {/* Mobile layout */}
        <div className="md:hidden grid grid-cols-2 w-full gap-0 bg-transparent">
          {stats.map((stat, idx) => (
            <div
              key={stat.value}
              className={`flex flex-col items-center px-2 py-4 bg-transparent ${
                idx % 2 === 0 ? 'border-r border-[#00000029]' : ''
              } ${idx < 2 ? 'border-b border-[#00000029]' : ''}`}
            >
              <span className="text-[40px] font-semibold mb-2">{stat.value}</span>
              <span className="text-[18px] leading-[24px] text-center font-normal text-black/72">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
